import React from 'react';
import PropTypes from 'prop-types';
import css from './WarningMessage.css';
import Icon from 'SF/MaterialIcon';

export default class WarningMessage extends React.Component {

  get dismissButton() {
    if ( !this.props.onDismiss ) return null;
    return (
      <div
        onClick={() => this.props.onDismiss(null) }
        aria-label="Dismiss"
        role="button"
        tabIndex="0">
        <Icon icon="close" />
      </div>
    );
  }

  render() {
    return (
      <div className={css['container']} role="alert">
        <div className={css['warning-container']}>
          <div><Icon aria-hidden="true" icon="warning"/></div>
          <div className={css['warning-text']}>{this.props.message}</div>
        </div>
        {this.dismissButton}
      </div>
    );
  }
}

WarningMessage.propTypes = {
  message: PropTypes.string.isRequired,
  onDismiss: PropTypes.func,
}
